<!-- 答辩成绩 -->
<template>
  <svg
    t="1748247291310"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="48131"
    width="200"
    height="200"
  >
    <path
      d="M799.6 809H224.1c-5.5 0-10-4.5-10-10V126.4c0-5.5 4.5-10 10-10h575.5c5.5 0 10 4.5 10 10V799c0 5.5-4.5 10-10 10z"
      fill="#FFFFFF"
      p-id="48132"
    />
    <path
      d="M799.6 829H224.1c-16.5 0-30-13.5-30-30V126.4c0-16.5 13.5-30 30-30h575.5c16.5 0 30 13.5 30 30V799c0 16.5-13.5 30-30 30z m-565.5-40h555.5V136.4H234.1V789z"
      fill="#03A9F4"
      p-id="48133"
    />
    <path
      d="M418.7 378.3h-94.4v-25.1h31.5v-96.8l-32.4 7.3v-25.9l64-13.5v128.8h31.3v25.2z"
      fill="#546E7A"
      p-id="48134"
    />
    <path
      d="M421.2 380.8h-99.4v-30.1h31.5v-91.2l-32.4 7.3v-31.1l69-14.6v129.4h31.3v30.3z m-94.4-5h89.4v-20.2h-31.3V227.4l-59 12.4v20.7l32.4-7.3v102.4h-31.5v20.2zM452.9 305.2c0-26.2 4.8-46.2 14.5-60 9.6-13.8 23.6-20.7 41.8-20.7 34.8 0 52.1 25.7 52.1 77.1 0 25.3-4.7 44.9-14.2 58.6-9.4 13.8-23.1 20.7-40.9 20.7-35.6 0.1-53.3-25.2-53.3-75.7z m31.9-0.8c0 34.9 7.5 52.3 22.4 52.3 14.6 0 22-18 22-53.9 0-36.1-7.1-54.1-21.4-54.1-15.4 0-23 18.6-23 55.7z"
      fill="#546E7A"
      p-id="48135"
    />
    <path
      d="M506 383.4c-15.2 0-27.5-4.6-36.5-13.5-12.7-12.6-19.1-34.4-19.1-64.7 0-26.6 5-47.3 15-61.4 10-14.4 24.8-21.8 43.8-21.8 36.2 0 54.6 26.8 54.6 79.6 0 25.8-4.9 46-14.6 60-9.8 14.4-24.3 21.8-43 21.8h-0.2z m3.2-156.4c-17.3 0-30.7 6.6-39.7 19.6-9.3 13.3-14.1 33-14.1 58.6 0 28.9 5.9 49.4 17.6 61.1 8 8 19.1 12.1 33 12.1h0.2c16.9 0 30-6.6 38.8-19.6 9.1-13.2 13.8-32.4 13.8-57.2 0-50.2-16.2-74.6-49.6-74.6z m-2 132.2c-16.5 0-24.9-18.4-24.9-54.8 0-39.2 8.3-58.2 25.5-58.2 16.1 0 23.9 18.5 23.9 56.6 0 37.4-8.2 56.4-24.5 56.4z m0.6-108c-13.6 0-20.5 17.9-20.5 53.2 0 33 6.7 49.8 19.9 49.8 12.9 0 19.5-17.3 19.5-51.4 0-34.2-6.4-51.6-18.9-51.6z"
      fill="#546E7A"
      p-id="48136"
    />
    <path
      d="M591.8 305.2c0-26.2 4.8-46.2 14.5-60 9.6-13.8 23.6-20.7 41.8-20.7 34.8 0 52.1 25.7 52.1 77.1 0 25.3-4.7 44.9-14.2 58.6-9.4 13.8-23.1 20.7-40.9 20.7-35.5 0.1-53.3-25.2-53.3-75.7z m31.9-0.8c0 34.9 7.5 52.3 22.4 52.3 14.6 0 22-18 22-53.9 0-36.1-7.1-54.1-21.4-54.1-15.3 0-23 18.6-23 55.7z"
      fill="#546E7A"
      p-id="48137"
    />
    <path
      d="M644.9 383.4c-15.2 0-27.4-4.6-36.4-13.6-12.7-12.7-19.1-34.4-19.1-64.6 0-26.6 5-47.3 15-61.4 10-14.4 24.8-21.8 43.8-21.8 36.2 0 54.6 26.8 54.6 79.6 0 25.8-4.9 46-14.6 60-9.8 14.4-24.3 21.8-43 21.8h-0.3z m3.2-156.4c-17.3 0-30.7 6.6-39.7 19.6-9.3 13.3-14.1 33-14.1 58.6 0 28.8 5.9 49.4 17.7 61.1 8.1 8 19.1 12.1 32.9 12.1h0.2c16.9 0 30-6.6 38.8-19.6 9.1-13.2 13.8-32.4 13.8-57.2 0-50.2-16.2-74.6-49.6-74.6z m-2 132.2c-16.5 0-24.9-18.4-24.9-54.8 0-38.6 8.6-58.2 25.5-58.2 16.1 0 23.9 18.5 23.9 56.6 0 37.4-8.2 56.4-24.5 56.4z m0.6-108c-13.6 0-20.5 17.9-20.5 53.2 0 33 6.7 49.8 19.9 49.8 12.9 0 19.5-17.3 19.5-51.4 0-34.2-6.4-51.6-18.9-51.6z"
      fill="#546E7A"
      p-id="48138"
    />
    <path
      d="M512 640H320.1v-64H512v64z m191.7-191.6H320.3v63.1h383.5l-0.1-63.1z"
      fill="#546E7A"
      p-id="48139"
    />
    <path
      d="M543.7 735.5c0 105.9 85.7 191.7 191.6 191.7S927 841.5 927 735.6v-0.1c0-105.9-85.7-191.7-191.6-191.7s-191.7 85.7-191.7 191.7c0-0.1 0-0.1 0 0z"
      fill="#43A047"
      p-id="48140"
    />
    <path
      d="M815.8 639.6L706.6 748.9l-51.7-51.7-40.2 42.2 92 92 149.5-149.5-40.4-42.3z"
      fill="#DCEDC8"
      p-id="48141"
    />
  </svg>
</template>
